import { render, staticRenderFns } from "./StorageHealth.vue?vue&type=template&id=d456bd42&"
import script from "./StorageHealth.vue?vue&type=script&lang=js&"
export * from "./StorageHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports